<template>
  <div class="saleTransport">
    <h1>销售 运价统计</h1>
    <el-form :inline="true">
      <el-form-item label="销售日期">
        <el-date-picker v-model="searchParam.dates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" border show-summary :summary-method="summary" height="calc(100vh - 310px)">
      <el-table-column prop="custom" label="客户" show-overflow-tooltip />
      <el-table-column prop="sendQuantity" label="销售数量" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.sendQuantity) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportPrice" label="运费单价" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportPrice) }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="transportSendAmount" label="运费合计" show-overflow-tooltip align="right">
        <template #default="scope">
          <span>{{ math.formatNumber(scope.row.transportSendAmount) }}</span>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import util from '../../utils/util'
import math from '../../utils/math'

const data = reactive({
  list: [],
  sendQuantity: null,
  transportSendAmount: null,
  transportPrice: null,
})

const now = new Date()
const yesterday = new Date(now.getTime() - 1 * 24 * 60 * 60 * 1000)
const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.dates = [yesterday, yesterday]
}
resetSearchParam()

const commitFindList = () => {
  data.list = []
  const params = {}
  if (searchParam.dates && searchParam.dates.length == 2) {
    params.dateGe = util.parseTime(searchParam.dates[0], '{y}-{m}-{d}')
    params.dateLe = util.parseTime(searchParam.dates[1], '{y}-{m}-{d}')
  } else {
    ElMessage.error('请选择时间')
    return
  }
  api.get('/backend/statistics/saleTransport', { params: params }).then(res => {
    data.list = res.list
    data.sendQuantity = res.sendQuantity
    data.transportSendAmount = res.transportSendAmount
    data.transportPrice = res.transportPrice
  })
}

const summary = () => {
  return [
    '合计',
    math.formatNumber(data.sendQuantity),
    math.formatNumber(data.transportPrice),
    math.formatNumber(data.transportSendAmount),
  ]
}

</script>

<style lang="less"></style>